import { Popover } from 'antd';
import { ReportItem } from 'store/ducks/Reporting/types';
import { InfoPopover } from '../InfoPopover';
import { InfoCircleOutlined } from '@ant-design/icons';
import { StyledInfoButton } from '../BusinessProcessTree.styled';

export const InfoButton = ({
  type,
  item
}: {
  type: 'process' | 'risk' | 'control' | 'gap' | 'audit' | 'solution' | 'bru';
  item: ReportItem;
}) => (
  <Popover placement='right' content={<InfoPopover type={type} item={item} />}>
    <StyledInfoButton
      size='small'
      shape='circle'
      icon={<InfoCircleOutlined />}
    />
  </Popover>
);
